import React from "react";
import useMedallero from "./useMedallero";
import { DEFAULT_EVENT_ID, DEFAULT_SPORT_ID } from "./medallero.utils";

import API_BASE_FORMATOS_URL from "../../config/config_formatos";

const getLogoSrc = (logoUrl) => {
  if (!logoUrl) return null;
  // Si ya es una URL absoluta (http/https), úsala directo
  if (/^https?:\/\//i.test(logoUrl)) return logoUrl;
  // Si es una ruta relativa, pégala a la base del backend
  const base = String(API_BASE_FORMATOS_URL).replace(/\/$/, "");
  return `${base}/${logoUrl.replace(/^\//, "")}`;
};

const InstitutionCell = ({ name, logoUrl }) => {
  const src = getLogoSrc(logoUrl);

  return (
    <div className="flex items-center gap-2 min-w-0">
      {src ? (
        <img
          src={src}
          alt={`Logo ${name}`}
          className="w-6 h-6 object-contain rounded-sm flex-shrink-0"
          onError={(e) => { e.currentTarget.style.display = "none"; }}
        />
      ) : (
        // Placeholder gris cuando no hay logo
        <div className="w-6 h-6 rounded-sm bg-gray-200 flex-shrink-0" />
      )}
      <span
        className="font-medium text-[#1a1a2e] overflow-hidden text-ellipsis whitespace-nowrap"
        title={name}
      >
        {name}
      </span>
    </div>
  );
};

const TablaFinal = () => {
  const { data, loading, error } = useMedallero(DEFAULT_EVENT_ID, DEFAULT_SPORT_ID);

  return (
    <div className="font-sans p-6 max-w-3xl mx-auto">
      <div className="mb-5">
        <h2 className="text-xl font-bold text-[#1a1a2e] m-0">Medallero General</h2>
      </div>

      {loading && (
        <p className="text-center py-8 text-gray-400 text-sm">Cargando medallero…</p>
      )}

      {error && (
        <p className="text-center px-4 py-3 text-red-600 bg-red-50 rounded-lg text-sm">
          {error}
        </p>
      )}

      {!loading && !error && data.length > 0 && (
        <table className="w-full border-collapse text-sm">
          <thead>
            <tr>
              <th className="bg-[#1a1a2e] text-white px-2 py-2.5 text-center font-semibold text-xs tracking-wide">#</th>
              <th className="bg-[#1a1a2e] text-white px-3 py-2.5 text-left font-semibold text-xs tracking-wide">Institución</th>
              <th className="bg-[#1a1a2e] text-white px-2 py-2.5 text-center font-semibold text-xs">🥇</th>
              <th className="bg-[#1a1a2e] text-white px-2 py-2.5 text-center font-semibold text-xs">🥈</th>
              <th className="bg-[#1a1a2e] text-white px-2 py-2.5 text-center font-semibold text-xs">🥉</th>
              <th className="bg-[#1a1a2e] text-white px-2 py-2.5 text-center font-semibold text-xs">5°</th>
              <th className="bg-[#1a1a2e] text-white px-2 py-2.5 text-center font-semibold text-xs">7°</th>
            </tr>
          </thead>
          <tbody>
            {data.map((row, i) => (
              <tr
                key={`${row.institutionId}-${i}`}
                className={i % 2 === 0 ? "bg-gray-50" : "bg-white"}
              >
                <td className="px-3 py-2.5 text-center font-bold text-[#1a1a2e] whitespace-nowrap">
                  {row.rank}°
                </td>
                {/* 👇 CELDA CON LOGO */}
                <td className="px-3 py-2.5 max-w-[260px]">
                  <InstitutionCell
                    name={row.institutionName}
                    logoUrl={row.institutionLogoUrl}
                  />
                </td>
                <td className="px-2 py-2.5 text-center font-bold text-[#b8860b]">{row.gold    || 0}</td>
                <td className="px-2 py-2.5 text-center font-bold text-[#888]"   >{row.silver  || 0}</td>
                <td className="px-2 py-2.5 text-center font-bold text-[#9a6224]">{row.bronze  || 0}</td>
                <td className="px-2 py-2.5 text-center font-bold text-[#555]"   >{row.fifth   || 0}</td>
                <td className="px-2 py-2.5 text-center font-bold text-[#555]"   >{row.seventh || 0}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {!loading && !error && data.length === 0 && (
        <p className="text-center py-8 text-gray-400 text-sm">
          No hay datos disponibles para este evento/deporte.
        </p>
      )}
    </div>
  );
};

export default TablaFinal;